import { ItineraryActionEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/itinerary-action.enum";
import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: 'app-route-itinerary-action-modal',
  styleUrl: './route-itinerary-action.component.scss',
  templateUrl: './route-itinerary-action.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatTooltipModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
  ],
})

export class ActionModalComponent {
  formData: FormGroup;
  actions: ItineraryActionEnum[] = []

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ActionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) { 
    this.actions = Object.values(ItineraryActionEnum);
    this.formData = this.fb.group({
      action: [[], [Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    this.initUpdateForm();
  }

  initUpdateForm(){
    this.formData.setValue({
      action: this.data.action ? this.data.action: [null],
    })
  }
  
  save() {
    this.data.action = this.formData.value.action;
    const dataToSend = Object.entries(this.data)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }
}